/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
//Import PageHeader
import PageHeader from "../../../components/PageHeader";
import Roles from "./Inner/Roles";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { permissionCheck } from "../../../utils/permission";

const ManagerTask = (props) => {
  const { permissions } = useSelector((store) => ({
    permissions: store.Profile.permissions
  }));
  const history = useHistory();
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'WORK_MANAGER_MANAGEMENT')
      setTargetPermission(permission)
      if (isEmpty(permission)) {
        permissionCheck(history, "WORK_MANAGER_MANAGEMENT")
      }
    }
  }, [permissions])


  return (
    !isEmpty(targetPermission) && (
      <div className="page-content">
        <PageHeader title={"업무 담당자 관리"} />
        <Roles permission={targetPermission} />
      </div>
    )
  );
};

export default ManagerTask;
